<script lang="ts">
	import { getGlobalSettings } from "../getGlobalSettings";

	const { COOKIES } = getGlobalSettings();

	/* eslint-disable svelte/no-at-html-tags */
</script>

{@html `<script type="text/javascript" charset="UTF-8" src="//cdn.cookie-script.com/s/${COOKIES}.js"></script>`}
